<template>
<div id="zeitplan-container" :class="{'lazy-icon': eventsLoading}">

  <h1>Bewegungskarte</h1>
    <div class="row">
      <div class="span12">
        <filter-bar :filter-values="filterValues" :filter="filter" :anyFiltersSet="anyFiltersSet" v-if="filterLoaded  && !hasPresetId" @reset-filter="resetFilter" @set-filter="setFilter" ref="filterBar" />
      </div>
    </div>
  <div id="layout-grid__area--herounit" class="fullwidth">
    <h3>Übersicht der Bewegungsangebote (Kartenansicht)</h3>



    <l-map style="height: 400px" :zoom="zoom" :center="center" :key="filterKey" id="map" v-if="getMapStatus()">
      <l-tile-layer :url="url" :attribution="attribution"></l-tile-layer>

      <v-marker-cluster>
        <l-marker :lat-lng="[e.lat, e.lng]" v-for="e in filteredEvents">
          <l-popup>
            <h4>{{ e.title }}</h4>
            <span class="title-meta club-name"><b>Verein/Träger:</b> {{ e.club }}</span>
            <div class="form-actions">
              <div class="form-actions__right">
                <a class="button" :href="`/angebote/${e.permalink}`">Kursdetails</a>
              </div>
            </div>
          </l-popup>
        </l-marker>
      </v-marker-cluster>
    </l-map>
    <div id="events_map" v-else>
      <div id="events_map-inner">
        <p>
        Diese Webseite verwendet den externen Kartendienst von
        <a href="https://www.openstreetmap.de/">OpenStreetMaps</a>.
        </p>
        <p><a target="blank" href="https://www.openstreetmap.org/copyright">Klicken Sie hier um die Lizenzbedingungen von OpenStreetMaps einzusehen</a>.</p>
        <p>
        Um die Bedingungen zu akzeptieren und die Nutzung dieses Dienstes zuzulassen
        <a id="map_preload_click" @click="confirmMapStatus($event)" href="#">klicken Sie bitte hier</a>.
        </p>
      </div>

    </div>
  </div>

  <div id="layout-grid__area--maincontent">
    <div class="row">
      <div class="span12" v-if="hasPresetId">
        <div class="block panel--heavy text-right">
          <a class="button" href="/karte">Alle Angebote auf Karte anzeigen</a>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="span12" id="currentEvents">
        <h3><b class="title-main" v-if="!hasPresetId">{{filteredEvents.length}} {{ filteredEvents.length == 1 ? 'Bewegungsangebot' : 'Bewegungsangebote'}}</b></h3>
        <events-list :events="filteredEvents" :loading="eventsLoading" context="map"  ref="eventsList" />
      </div>
    </div>
  </div>

</div>
</template>
<script>

import filterLoader from '../mixins/filterLoader.js'

import EventsList from "../components/_eventsList.vue"
import FilterBar from "../components/_filter.vue"
import axios from 'axios'
import moment from 'moment'

export default {
  name: 'Zeitplan',
  mixins: [filterLoader],
	components: {
    EventsList,
    FilterBar
	},
  data(){
    return {
      url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
      attribution:
        '&copy; <a target="_blank" href="http://osm.org/copyright">OpenStreetMap</a> contributors',
      zoom: 12,
      center: [52.51811127849241, 13.377773518816989],
      presetId: null,
    };
  },
  created(){
    // settoing tab indices
    this.setTabIndices("#header a, #header button")
    const mapElement = document.getElementById("karte-vue")
    const lat = parseFloat(mapElement.dataset.lat)
    const lng = parseFloat(mapElement.dataset.lng)
    const id_string = mapElement.dataset.id

    if (!isNaN(lat) && !isNaN(lng)) {
      this.center = [lat, lng]
      this.zoom = 15
    }
    this.presetId = id_string ? BigInt(id_string) : null

    this.loadEvents()
  },
  computed: {
    hasPresetId(){
      return this.presetId != null
    }
  },
  methods: {
    getMapStatus(){
      if (localStorage.getItem("mapOSM") == 'true'){
        return true
      }else{
        return false
      }
    },

    confirmMapStatus(e){
      e.preventDefault()
      if (window.confirm("Bitte bestätigen Sie die Nutzung von OpenStreetMaps.")){
        localStorage.setItem("mapOSM", true)
        window.location.reload()
      }
    },

    setTabIndices(selector, start = 1){
      var elements = document.querySelectorAll(selector)

      elements.forEach((e,i) => {
        e.setAttribute('tabindex', start+i)
      })
    },
    loadEvents(){
      this.eventsLoading = true
      axios.get("/events/dates", {params: {preset_id: this.presetId }})
      .then(r => {
        this.events = r.data.events
        this.eventsLoading = false
      })
    }
  }

}
</script>
<style>
.vue2leaflet-map { height: 300px; margin-bottom: 20px; z-index: 1;}
</style>
